import React from 'react'
import { Dialog } from '@material-ui/core'

import UserRoleSelector from './UserRoleSelector'

const UserRoleDialog = props => {
  const { role, onClose } = props
  const onSave = (assignedUsers) => console.log('assigning users:', assignedUsers)

  return <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth>
    <UserRoleSelector role={role} onSave={onSave} onClose={onClose} />
  </Dialog>
}

export default UserRoleDialog
